export default __webpack_public_path__ + "static/media/travel-guru.d9a891b5.PNG";